<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!totals || !totals.total_cnt" class="dw-empty">No actuals processed yet this period.</div>
    <div v-else class="dw-stat-grid">
      <div class="dw-stat-tile">
        <div class="dw-stat-tile-label">Total</div>
        <div class="dw-stat-tile-value">{{ totals.total_cnt }}</div>
      </div>
      <div class="dw-stat-tile">
        <div class="dw-stat-tile-label">Success</div>
        <div class="dw-stat-tile-value">{{ totals.success_cnt }}</div>
      </div>
      <div class="dw-stat-tile">
        <div class="dw-stat-tile-label">Errors</div>
        <div class="dw-stat-tile-value">{{ totals.error_cnt }}</div>
      </div>
      <div class="dw-stat-tile">
        <div class="dw-stat-tile-label">Cancelled</div>
        <div class="dw-stat-tile-value">{{ totals.cancelled_cnt }}</div>
      </div>
      <div class="dw-stat-tile">
        <div class="dw-stat-tile-label">Unprocessed</div>
        <div class="dw-stat-tile-value">{{ totals.unprocessed_cnt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget_actuals_summary',
  props: {
    totals: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
}
</script>
